import { __awaiter } from 'tslib';
import '../../services/base/baseDiscoverService.js';
import '../../services/base/baseV3Service.js';
import '../../services/sgtService.js';
import '@analytics/storage-utils';
import 'date-fns/format';
import 'date-fns/secondsToMinutes';
import 'date-fns/isValid';
import 'date-fns/addMinutes';
import 'date-fns';
import 'date-fns-tz';
import { useState } from 'react';
import '../../utils/ErrorProvider.js';
import '../../utils/LoaderProvider.js';
import '../../utils/RefetchProvider.js';
import '../../utils/NotificationProvider.js';
import '../../utils/ContactProvider.js';
import '../../utils/PolicyProvider.js';
import '../../utils/AnalyticsProvider.js';
import '../../types/AccessDevice.js';
import '../../types/Analytics.js';
import '../../types/CASACommunity.js';
import '../../types/Community.js';
import '../../types/DxSettings.js';
import '../../types/MagicButton.js';
import '../../types/Pannellum.js';
import '../../types/Prospect.js';
import '../../types/ProspectIntelligence.js';
import '../../types/Space.js';
import '../../types/Tour.js';
import '../../utils/analyticsPlugin.js';
import '../../utils/communityGoogleAnalyticsPlugin.js';
import 'qs';
import '../../utils/cookieUtils.js';
import '../../utils/termsConditionsAgreementsUtils.js';
import '../../services/base/analyticsV2BaseService.js';
import 'axios';
import '../../services/base/internalApiBaseService.js';
import '../../services/base/casaBaseService.js';
import { bulkUpdateScanRequest } from '../../services/scanRequestsService.js';
import '../../services/db/insightsReportsDB.js';
import useAbortController from '../useAbortController.js';

const useBulkUpdateScanRequests = () => {
    const [updatedScanRequests, setUpdatedScanRequests] = useState(null);
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(false);
    const { controller, abortIfNeeded } = useAbortController();
    const api = (scanRequests) => __awaiter(void 0, void 0, void 0, function* () {
        abortIfNeeded();
        try {
            setLoading(true);
            setUpdatedScanRequests(null);
            setError(null);
            const res = yield bulkUpdateScanRequest({ scanRequests }, { signal: controller.current.signal });
            setUpdatedScanRequests(res);
        }
        catch (error) {
            if (error.message !== "canceled") {
                setError(error);
                setLoading(false);
            }
        }
        finally {
            setLoading(false);
        }
    });
    return [api, updatedScanRequests, loading, error];
};

export { useBulkUpdateScanRequests };
